import { GET_REPORT_SUCCESS, GET_REPORT_FAILURE, GET_REPORT_PENDING } from "./actionTypes";

const initialState = {
  reports: [],
  count: 0,
  loading: true,
  failed: false,
  error: {},
};

function reportReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_REPORT_SUCCESS:
      return {
        ...state,
        reports: payload.list,
        count: payload.count,
        failed: false,
        loading: false,
      };

    case GET_REPORT_FAILURE:
      return { ...state, failed: true, loading: false, error: payload.error };

    case GET_REPORT_PENDING:
      return { ...state , loading : true };

    default:
      return state;
  }
}

export default reportReducer;
